module.exports = "https://img1.huilianyi.com/c/blank.c7a0f09841.appcore.png";